/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import CircleButton from './CircleButton';

export default class AgainButtons extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.btnQuiz = new CircleButton(this.scene, '0xFFCC00', ABCyaPhaser.Localization.instance.getLocalizedString('quiz_again_button'));
    this.add(this.btnQuiz);
    this.btnQuiz.bg.setInteractive();
    this.btnQuiz.bg.on('pointerup', () => {this.onClickQuiz();});

    this.btnLearn = new CircleButton(this.scene, '0xFFCC00', ABCyaPhaser.Localization.instance.getLocalizedString('learn_again_button'));
    this.add(this.btnLearn);
    this.btnLearn.bg.setInteractive();
    this.btnLearn.bg.on('pointerup', () => {this.onClickLearn();});

    this.btnLearn.x = this.btnQuiz.bgSize + 320;
  }

  onClickQuiz() {
    this.emit('QUIZ');
  };

  popinButtons() {
    this.btnQuiz.scaleX = 0;
    this.btnQuiz.scaleY = 0;
    ABCyaPhaser.Tweens.addTween(this.btnQuiz, 400, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);

    this.btnLearn.scaleX = 0;
    this.btnLearn.scaleY = 0;
    ABCyaPhaser.Tweens.addTween(this.btnLearn, 400, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out);
  };

  onClickLearn() {
    this.emit('LEARN');
  };
}